export default __webpack_public_path__ + "static/media/b3.a504a7ab.jpeg";